import axios, { AxiosInstance } from 'axios'

const defaultHeaders: Record<string, string> = {
  Accept: 'application/json',
}

export function UnauthenticatedHttpClient(): AxiosInstance {
  return axios.create({
    headers: defaultHeaders,
  })
}
